<aside class="sidebar" [class.sidebar--collapsed]="isCollapsed()">

  <!-- ── Header ────────────────────────────────────────────────── -->
  <div class="sidebar__header">
    <span class="sidebar__brand">
      <svg class="sidebar__brand-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="36" height="36" aria-hidden="true">
        <rect width="40" height="40" rx="8" fill="#1e88e5"/>
        <text x="50%" y="54%" dominant-baseline="middle" text-anchor="middle"
              font-family="'Segoe UI', Arial, sans-serif" font-size="26" font-weight="700" fill="#ffffff">S</text>
      </svg>
    </span>

    <button class="sidebar__toggle" type="button" (click)="toggle()" aria-label="Colapsar menú">
      <i class="pi pi-angle-left" aria-hidden="true"></i>
    </button>
  </div>

  <!-- ── Navigation ─────────────────────────────────────────────── -->
  <nav class="sidebar__nav" aria-label="Navegación principal">
    <ul class="sidebar__list" role="list">

      @for (group of menuItems(); track trackById($index, group)) {

        <!-- ── Leaf item (no children) ─── -->
        @if (!hasChildren(group)) {
          <li class="sidebar__item">
            <a class="sidebar__link"
               [routerLink]="group.route"
               routerLinkActive="is-active"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="handleNavigate()">
              <span class="sidebar__icon" aria-hidden="true">
                <ng-container *ngTemplateOutlet="iconTpl; context: { $implicit: group.icon }"></ng-container>
              </span>
              <span class="sidebar__label">{{ group.label }}</span>
            </a>
          </li>

        <!-- ── Group with children ─── -->
        } @else {
          <li class="sidebar__group" [class.is-open]="isOpen(group.id)">

            <button class="sidebar__group-btn"
                    type="button"
                    (click)="expandAndOpen(group.id)"
                    [attr.aria-expanded]="isOpen(group.id)">
              <span class="sidebar__icon" aria-hidden="true">
                <ng-container *ngTemplateOutlet="iconTpl; context: { $implicit: group.icon }"></ng-container>
              </span>
              <span class="sidebar__label">{{ group.label }}</span>
              <i class="pi pi-angle-down sidebar__chevron" aria-hidden="true"></i>
            </button>

            <div class="sidebar__submenu" [class.is-open]="isOpen(group.id)">
              <ul class="sidebar__sublist" role="list">

                @for (item of group.children; track trackById($index, item)) {

                  <!-- ── Level-2 leaf ─── -->
                  @if (!hasChildren(item)) {
                    <li class="sidebar__subitem">
                      <a class="sidebar__sublink"
                         [routerLink]="item.route"
                         routerLinkActive="is-active"
                         [routerLinkActiveOptions]="{ exact: true }"
                         (click)="handleNavigate()">
                        <span class="sidebar__dot" aria-hidden="true"></span>
                        <span>{{ item.label }}</span>
                      </a>
                    </li>

                  <!-- ── Level-2 group ─── -->
                  } @else {
                    <li class="sidebar__subgroup" [class.is-open]="isOpen(item.id)">
                      <button class="sidebar__subgroup-btn"
                              type="button"
                              (click)="toggleGroup(item.id)"
                              [attr.aria-expanded]="isOpen(item.id)">
                        <span class="sidebar__dot" aria-hidden="true"></span>
                        <span>{{ item.label }}</span>
                        <i class="pi pi-angle-down sidebar__chevron sidebar__chevron--sm" aria-hidden="true"></i>
                      </button>

                      <div class="sidebar__submenu sidebar__submenu--nested" [class.is-open]="isOpen(item.id)">
                        <ul class="sidebar__sublist sidebar__sublist--nested" role="list">
                          @for (leaf of item.children; track trackById($index, leaf)) {
                            <li class="sidebar__subitem">
                              <a class="sidebar__sublink sidebar__sublink--nested"
                                 [routerLink]="leaf.route"
                                 routerLinkActive="is-active"
                                [routerLinkActiveOptions]="{ exact: true }"
                                (click)="handleNavigate()">
                                <span class="sidebar__dot sidebar__dot--sm" aria-hidden="true"></span>
                                <span>{{ leaf.label }}</span>
                              </a>
                            </li>
                          }
                        </ul>
                      </div>
                    </li>
                  }

                }

              </ul>
            </div>

          </li>
        }

      }

    </ul>
  </nav>

</aside>

<!-- ── PrimeIcons icon template ────────────────────────────────── -->
<ng-template #iconTpl let-icon>
  @switch (icon) {
    @case ('home')        { <i class="pi pi-home"></i> }
    @case ('lock')        { <i class="pi pi-lock-open"></i> }
    @case ('chart-bar')   { <i class="pi pi-chart-bar"></i> }
    @case ('bell')        { <i class="pi pi-bell"></i> }
    @case ('dollar')      { <i class="pi pi-dollar"></i> }
    @case ('wrench')      { <i class="pi pi-wrench"></i> }
    @case ('certificate') { <i class="pi pi-verified"></i> }
    @case ('briefcase')   { <i class="pi pi-briefcase"></i> }
    @case ('cloud')       { <i class="pi pi-cloud"></i> }
    @case ('code')        { <i class="pi pi-code"></i> }
    @case ('star')        { <i class="pi pi-star"></i> }
    @default              { <i class="pi pi-circle"></i> }
  }
</ng-template>
